(function () {
    'use strict';

    angular
        .module('homeControllers')
        .controller('HomeWithSolrController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', '$location', 'topBarService', 'historyCtxtService', 'searchV2Service', 'planInitiativeSelectionService'];

    function Controller($scope, $state, $stateParams, $location, topBarService, historyCtxtService, searchV2Service, planInitiativeSelectionService) {

        $scope.searchCtx = {};
        $scope.searchCtx.q = $stateParams.q;

        $scope.planInitiativeSelectionService = planInitiativeSelectionService.init();
        $scope.searchCtx.manageInitiativesMode = $location.hash().indexOf('mode=' + $scope.planInitiativeSelectionService.mode) > -1;
        $scope.searchCtx.managePSSMode = $location.hash().indexOf('mode=managePSSInitiatives') > -1;

        setPageTitle();

        if ($scope.searchCtx.manageInitiativesMode) {
            $scope.planInitiativeSelectionService.onCancelMode = function () {
                $location.hash($location.hash().replace('mode=' + $scope.planInitiativeSelectionService.mode, ''));
                $scope.searchCtx.manageInitiativesMode = false;
                $scope.selectionService = null;
                setPageTitle();
            };
            $scope.selectionService = $scope.planInitiativeSelectionService;
        }

        // If no context is defined, load all results based on URL
        if (!$scope.searchCtx.searchCtxt) {
	        searchV2Service
		        .initializeSearch([
			        'Employee',
			        'Procedure',
			        'BusinessUnit',
			        'Committee',
			        'GlossaryTerm',
			        'AuditMandate',
			        'CorporateRole',
			        'Control',
			        'Risk',
			        'RiskEvent',
			        'PlanInitiative',
			        'RecomActionPlan',
			        'Recommendation',
			        'BIAProfile',
					'Responsibility'
                ], $stateParams)
                .then(function (searchCtxt) {
                    _.assign(searchCtxt, $stateParams);
                    $scope.searchCtx.searchCtxt = searchCtxt;
                });
        }

        function setPageTitle() {
            var pageTitle = 'Advanced Search';
            var pageIcon  = 'fa fa-search';

            if ($scope.searchCtx.manageInitiativesMode)  {
                pageTitle = 'Manage Plan Initiatives';
                pageIcon  = 'fa fa-compass';
            } else if ($scope.searchCtx.managePSSMode)  {
                pageTitle = 'Business planning process > Preliminary Scope Statement';
                pageIcon  = 'fa fa-compass';
            }

            topBarService.setModule(undefined);
            topBarService.setTitleAndIcon(pageTitle, pageIcon);
        }

        // Source Type Changed
        $scope.onSourceTypeChanged = function () {
            if ($scope.searchCtx.manageInitiativesMode) {
                $scope.planInitiativeSelectionService.cancelMode();
            }
        };

        // Facet Changed
        $scope.onFacetChanged = function () {
            if ($scope.searchCtx.manageInitiativesMode) {
                $scope.planInitiativeSelectionService.resultsChanged();
            }
        };

        // Search function
        $scope.searchAdvanced = function (q) {

            if (q === undefined) {
                q = '';
            }

            if (q.length >= 0) {
                $scope.searchCtx.isSearching = true;
                $scope.searchCtx.isLoading = true;

                searchV2Service.search({q: $scope.searchCtx.q}).then(function (searchCtxt) {

                    $scope.searchCtx.isSearching = false;
                    $scope.searchCtx.isLoading = false;
                    $scope.searchCtx.searchCtxt = searchCtxt;

                    if ($scope.searchCtx.manageInitiativesMode) {
                        $scope.planInitiativeSelectionService.resultsChanged();
                    }
                });

            }
         
            if (!$scope.$$phase) $scope.$apply();
        };

        // Go To Risk
        $scope.goToRisk = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('riskEdit', {
                RiskID: item.RiskID
            },
                $state.current.name
            );
        };

        // Go To Control
        $scope.goToControl = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('control', {
                ControlID: item.ControlID
            },
                $state.current.name
            );
        };

        // Go To ActionPlan
        $scope.goToActionPlan = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('recommendation.edit.actionPlan.edit', {
                    RecommendationID: item.RecommendationID,
                    ActionPlanID: item.ActionPlanID
            },
                $state.current.name
            );
        };

        // Go To Recommendation
        $scope.goToRecommendation = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('recommendation.edit', {
                RecommendationID: item.RecommendationID
            },
                $state.current.name
            );
        };

        // Go To Audit Mandate
        $scope.goToAuditMandate = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('auditMandateEdit', {
                AuditMandateID: item.AuditMandateID
            },
                $state.current.name
            );
        };
        

        // Go To CorporateRole
        $scope.goToCorporateRole = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('corporateRole', {
                CorporateRoleID: item.CorporateRoleID
            },
                $state.current.name
            );
        };

        //Search People
        $scope.goToPeople = function (personName) {

            $scope.searchCtx.q           = personName;
            $scope.searchCtx.isSearching = true;
            $scope.searchCtx.isLoading   = true;
            searchV2Service.search({q: $scope.searchCtx.q, sourceType: undefined, sf: null}).then(function (searchCtxt) {

                $scope.searchCtx.isSearching = false;
                $scope.searchCtx.isLoading   = false;
                $scope.searchCtx.searchCtxt  = searchCtxt;
            });

        };

        // Go To Observation
        $scope.goToObservation = function (item) {
            searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('observation.edit', {
                ObservationID: item.ObservationID
            },
                $state.current.name
            )
        };

        // Go To Risk Event
        $scope.goToRiskEvent = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('riskEventEdit', {
                RiskEventID: item.RiskEventID
            },
                $state.current.name
            );
        };

        // Go to Plan Initiative
        $scope.goToPlanInitiative = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;

            // Navigate while keeping the hash part
            historyCtxtService.goToStateWithOptions('initiative.edit', {
                toStateParams: {InitiativeID: item.PlanInitiativeID},
                ctxStateName: $state.current.name,
                ctxtHash: $location.hash()
            });
        };

        // Go to Procedure
        $scope.goToProcedure = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('procedure.view', {
                    ProcedureType: item.ProcedureTypeValue,
                    ProcedureCode: item.ProcedureCodeFull
                },
                $state.current.name
            );
        };

        // Go To Reference Document
        $scope.goToReferenceDocument = function (refDoc) {
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('procedure.view', {
                    ProcedureType: refDoc.MetadataBlock.ProcedureType.Value,
                    ProcedureCode: refDoc.MetadataBlock.ProcedureCode.Code
                },
                $state.current.name
            );
        };

        // Go To Committee
        $scope.goToCommittee = function (item) {
            $scope.searchCtx.searchSuggestions = false;
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('committee',
              { CommitteeID: item.CommitteeID },
              $state.current.name
            );
        };

        // Go To Glossary Term
        $scope.goToGlossaryTerm = function (item) {
            $scope.searchCtx.searchSuggestions = false;
            $scope.searchCtx.isLeftBarOpen = false;
            historyCtxtService.goToState('glossaryTerm',
              { GlossaryTermID: item.LookupAttributeValueID },
              $state.current.name
            );
        };

        // Go To BIA Profile
        $scope.goToBIAProfile = function (item) {
            $scope.searchCtx.isLeftBarOpen = false;
            $scope.searchCtx.searchSuggestions = false;

            historyCtxtService.goToState('biaProfile.edit', {
                BIAProfileID: item.BIAProfileID
            },
                $state.current.name
            );
        };

	    // Go To Responsibility
        $scope.goToResponsibility = function (item) {
	        $scope.searchCtx.isLeftBarOpen = false;
	    	$scope.searchCtx.searchSuggestions = false;

	    	historyCtxtService.goToState('responsibility', {
					ResponsibilityID: item.ResponsibilityID
				},
			    $state.current.name
		    );
	    };

    }
})();